import { EllipsedText, LabeledData, useMoment } from '@gorila-shared-ui/components';
import { Block } from 'baseui/block';
import { Cell, Grid } from 'baseui/layout-grid';
import { StyledLink } from 'baseui/link';
import { memo } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { SecondaryDeviceDetail } from '../../types/device';

type Props = {
  device: SecondaryDeviceDetail;
};

function MultipleDeviceCardBody({ device }: Props) {
  const { css, theme } = useStyles();
  const { formatDateFromTs } = useMoment();

  return (
    <Block
      className={css({
        padding: theme.sizing.scale600,
        height: '80px',
      })}
    >
      <Grid
        gridColumns={3}
        gridGaps={[8]}
        gridGutters={[16]}
        gridMargins={[0]}
      >
        <Cell span={[12]}>
          <LabeledData
            label={'Dirección:'}
            content={
              <StyledLink
                href={`https://maps.google.com/?q=${device.position_latitude},${device.position_longitude}`}
                target="_blank"
                style={{ color: theme.colors.contentSecondary, ...theme.typography.ParagraphSmall }}
              >
                <EllipsedText
                  inline
                  breakAll
                >
                  {device.geoReference}
                </EllipsedText>
              </StyledLink>
            }
          />
        </Cell>
        <Cell>
          <LabeledData
            label={'Odómetro:'}
            content={`${device.gnss_vehicle_mileage} Km`}
          />
        </Cell>
        <Cell>
          <LabeledData
            label={'Velocidad:'}
            content={`${device.position_speed} Km/h`}
          />
        </Cell>
        <Cell>
          <LabeledData
            label={'Alimentación:'}
            content={`${device.external_powersource_voltage || 0}`}
          />
        </Cell>
        <Cell span={[12]}>
          <LabeledData
            label={'Fecha:'}
            content={`${formatDateFromTs(+device.timestamp)}`}
          />
        </Cell>
      </Grid>
    </Block>
  );
}

export default memo(MultipleDeviceCardBody);
